// router.tsx
import { createBrowserRouter } from 'react-router-dom';
import LoginScreen from '../loginScreen/LoginScreen';
import TestScreen from '../testScreen/TestScreen';
import TestScreenV2 from '../testScreen/TestScreenV2';
import PersonalizationScreen from '../PersonalizationScreen';
import ProtectedRoute from './ProtectedRoutes';
import { MainLayout } from '../../layouts/MainLayout';

// Enable below line code if environment variable REACT_APP_USE_TEST_V2 is working fine.
// const Test = process.env.REACT_APP_USE_TEST_V2 === 'true' ? TestScreenV2 : TestScreen;
const Test = TestScreenV2;

export const router = createBrowserRouter([
    {
        element: <MainLayout />,
        children: [
            {
                path: '/',
                element: <LoginScreen />,
            },
            {
                element: <ProtectedRoute />,
                children: [
                    { path: '/precheck', element: <PersonalizationScreen /> },
                    { path: '/test', element: <Test /> },
                ],
            },
            {
                path: '*',
                element: <ProtectedRoute />,
            },
        ],
    },
]);
